var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative y-input"
  }, [_vm.required ? _c('span', {
    staticClass: "absolute right-0 pr-1 text-2xl text-red-500"
  }, [_vm._v("*")]) : _vm._e(), _vm.alertIcon ? _c('Icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: 'Modified from LLM Translation',
      expression: "'Modified from LLM Translation'"
    }],
    staticClass: "absolute right-0 top-0 mt-1 mr-1 text-pink-400 bg-white",
    attrs: {
      "name": "pencil",
      "size": 4
    }
  }) : _vm._e(), _c('div', {
    staticClass: "absolute right-0 bottom-0 mb-2 mr-3 flex"
  }, [_vm.tooltip ? _c('Icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.tooltip,
      expression: "tooltip"
    }],
    staticClass: "mr-1 text-gray-400 bg-white",
    attrs: {
      "name": "helpCircle",
      "size": 4
    }
  }) : _vm._e(), _vm._l(_vm.icons, function (icon) {
    return _c('Icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: icon ? icon.tooltip : null,
        expression: "icon ? icon.tooltip : null"
      }],
      key: icon.name,
      staticClass: "text-gray-400 bg-white",
      attrs: {
        "name": icon.name,
        "size": 4
      }
    });
  })], 2), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    ref: "input",
    staticClass: "input",
    class: [_vm.inputClass, _vm.internalValue ? 'filled' : ''],
    attrs: {
      "id": _vm.id,
      "name": _vm.label ? _vm.label.toLowerCase() : null,
      "type": _vm.type,
      "autofocus": "",
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "alertIcon": _vm.alertIcon,
      "maxlength": _vm.characterLimit
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "paste": function (event) {
        return _vm.$emit('paste', event);
      },
      "blur": function (event) {
        return _vm.$emit('blur', event);
      },
      "keypress": function (event) {
        return _vm.$emit('keypress', event);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.internalValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer-events-none label absolute mb-0 -mt-2 pt-4 pl-3 leading-tighter text-gray-400 text-base mt-2 cursor-text",
    attrs: {
      "for": _vm.label ? _vm.label.toLowerCase() : null
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm.characterLimitReached ? _c('div', {
    staticClass: "text-red-800 flex items-center gap-1"
  }, [_c('Icon', {
    attrs: {
      "name": "alertCircle",
      "size": 4
    }
  }), _vm._v("Character Limit Reached ")], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }